const CROSS_WORKSPACE_MOVE_AND_STITCH_NOTE = 'Cross-workspace move and stitch are not supported.';

export const CROSS_WORKSPACE_DROP_TEXT = {
  note: CROSS_WORKSPACE_MOVE_AND_STITCH_NOTE,
  notebookNote: `Copying a notebook across workspaces is not supported yet. ${CROSS_WORKSPACE_MOVE_AND_STITCH_NOTE}`,
  notebookCopyTooltip: 'Cross-workspace notebook copy is not supported yet.',
  moveTooltip: 'Cross-workspace move is not supported.',
  stitchTooltip: 'Cross-workspace stitching is not supported.',
} as const;
